const saveQuoteCheckType = {
  checkCustomerType: 'checkCustomerType',
  checkExpireDate: 'checkExpireDate',
  checkExpectedDeliveryDate: 'checkExpectedDeliveryDate',
}
export default saveQuoteCheckType
